import React, { useState } from "react";
import PersonalDetailsFields from "./PersonalDetailsFields";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import SubmitButton from "../../components/button/SubmitButton";
import BeneficiaryAudioGramController from "./AudioGram/BeneficiaryAudioGramController";

const CreateUi = ({
  fields,
  fieldErrors,
  setFields,
  setFieldErrors,
  loading,
  createFunction,
  step,
  setStep,
}) => {
  console.log("first step fields", step);
  return (
    <>
      <Paper sx={{ p: 4, width: "100%", height: "100%" }}>
        {step == 0 && (
          <>
            <Box>
              <Typography variant="h6" mb={2}>
                Add Beneficiary
              </Typography>
            </Box>
            <PersonalDetailsFields
              show={step == 0}
              fields={fields}
              fieldErrors={fieldErrors}
              setFields={setFields}
              setFieldErrors={setFieldErrors}
              loading={loading}
            />
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
              mt={2}
            >
              <SubmitButton
                onClick={(e) => { fields?._id ? setStep(1) : createFunction(e); }}
                loading={loading}
                type="submit"
                title={"Next"}
                sx={{ width: "20%" }}
              />
            </Box>
          </>
        )}
        {step == 1 && <BeneficiaryAudioGramController setBackStep={setStep} id={fields?._id} fieldsdata={fields} setFieldsdata={setFields} />}
      </Paper>
    </>
  );
};

export default CreateUi;
